import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    minHeight: '100px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  }
}))

const ComponentLoader = ({ loading, style }) => {
  const classes = useStyles()
  if (loading)
    return (
      <div style={style} className={classes.root}>
        <CircularProgress />
      </div>
    )
  return null
}

export default ComponentLoader
